import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import BreadCrumb from "../../components/Breadcrumb";
import FaqItem from "../../components/FaqItem";
import { faqData } from "../../constants/faqData";
const Faq = () => {
  const [activeSection, setActiveSection] = useState("All");
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState(faqData);

  useEffect(() => {
    let data = faqData.filter(
      (x) =>
        x.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
        x.answer.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredData(data);
  }, [searchTerm]);

  return (
    <div className="faq-page">
      <BreadCrumb pageName="FAQS" />
      <div className="row">
        <div className="col-sm-6">
          <h3 className="page-title">Frequently Asked Questions</h3>
          <p className="page-desc">Questions and answers</p>
        </div>
      </div>
      <div className="container-faq">
        <div className="filter-section">
          <div className="search-bar">
            <FontAwesomeIcon icon={faSearch} />
            <input
              placeholder="Search"
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <select
            className="dropdown"
            onChange={(e) => {
              setActiveSection(e.target.value);
            }}
          >
            <option value="All">All</option>
            <option value="Costs and Commissions">Costs and Commissions</option>
            <option value="Compounding Service">Compounding Service</option>
            <option value="Quality Assurance">Quality Assurance</option>
            <option value="Creating a Raw Rx">Creating a Raw Rx</option>
            <option value="Creating a Granular Rx">
              Creating a Granular Rx
            </option>
            <option value="Converting from Raw to Granular">
              Converting from Raw to Granular
            </option>
            <option value="Converting from Granular to Raw">
              Converting from Granular to Raw
            </option>
            <option value="Adding notes">Adding notes</option>
            <option value="Saving a new formula">Saving a new formula</option>
            <option value="Formulas Tab">Formulas Tab</option>
            <option value="Prescription Tab">Prescription Tab</option>
            <option value="Patient Tab">Patient Tab</option>
            <option value="Software">Software</option>
            <option value="Account & Privacy">Account & Privacy</option>
            <option value="Shipping & Payments">Shipping & Payments</option>
            <option value="Herbs & Instructions">Herbs & Instructions</option>
            <option value="Security & Privacy">Security & Privacy</option>
            <option value="Payments, Shipping & Returns">
              Payments, Shipping & Returns
            </option>
            <option value="Other">Other</option>
            <option value="Safety">Safety</option>
          </select>
        </div>

        {(activeSection === "All" ||
          activeSection === "Costs and Commissions") &&
          filteredData.some((x) => x.category === "Costs and Commissions") && (
            <div className="detail-section">
              <div className="header-section">
                <h1>Costs and Commissions</h1>
                <hr className="line" />
              </div>
              {filteredData
                .filter((x) => x.category === "Costs and Commissions")
                .map((item, index) => {
                  return (
                    <FaqItem
                      key={index}
                      question={item.question}
                      answer={item.answer}
                    />
                  );
                })}
            </div>
          )}

        {(activeSection === "All" || activeSection === "Compounding Service") &&
          filteredData.some((x) => x.category === "Compounding Service") && (
            <div className="detail-section">
              <div className="header-section">
                <h1>Compounding Service</h1>
                <hr className="line" />
              </div>
              {filteredData
                .filter((x) => x.category === "Compounding Service")
                .map((item, index) => {
                  return (
                    <FaqItem
                      key={index}
                      question={item.question}
                      answer={item.answer}
                    />
                  );
                })}
            </div>
          )}

        {(activeSection === "All" || activeSection === "Quality Assurance") &&
          filteredData.some((x) => x.category === "Quality Assurance") && (
            <div className="detail-section">
              <div className="header-section">
                <h1>Quality Assurance</h1>
                <hr className="line" />
              </div>
              {filteredData
                .filter((x) => x.category === "Quality Assurance")
                .map((item, index) => {
                  return (
                    <FaqItem
                      key={index}
                      question={item.question}
                      answer={item.answer}
                    />
                  );
                })}
            </div>
          )}

        {(activeSection === "All" || activeSection === "Creating a Raw Rx") &&
          filteredData.some((x) => x.category === "Creating a Raw Rx") && (
            <div className="detail-section">
              <div className="header-section">
                <h1>Creating a Raw Rx</h1>
                <hr className="line" />
              </div>
              {filteredData
                .filter((x) => x.category === "Creating a Raw Rx")
                .map((item, index) => {
                  return (
                    <FaqItem
                      key={index}
                      question={item.question}
                      answer={item.answer}
                    />
                  );
                })}
            </div>
          )}

        {(activeSection === "All" ||
          activeSection === "Creating a Granular Rx") &&
          filteredData.some((x) => x.category === "Creating a Granular Rx") && (
            <div className="detail-section">
              <div className="header-section">
                <h1>Creating a Granular Rx</h1>
                <hr className="line" />
              </div>
              {filteredData
                .filter((x) => x.category === "Creating a Granular Rx")
                .map((item, index) => {
                  return (
                    <FaqItem
                      key={index}
                      question={item.question}
                      answer={item.answer}
                    />
                  );
                })}
            </div>
          )}

        {(activeSection === "All" ||
          activeSection === "Converting from Raw to Granular") &&
          filteredData.some(
            (x) => x.category === "Converting from Raw to Granular"
          ) && (
            <div className="detail-section">
              <div className="header-section">
                <h1>Converting from Raw to Granular</h1>
                <hr className="line" />
              </div>
              {filteredData
                .filter((x) => x.category === "Converting from Raw to Granular")
                .map((item, index) => {
                  return (
                    <FaqItem
                      key={index}
                      question={item.question}
                      answer={item.answer}
                    />
                  );
                })}
            </div>
          )}

        {(activeSection === "All" ||
          activeSection === "Converting from Granular to Raw") &&
          filteredData.some(
            (x) => x.category === "Converting from Granular to Raw"
          ) && (
            <div className="detail-section">
              <div className="header-section">
                <h1>Converting from Granular to Raw</h1>
                <hr className="line" />
              </div>
              {filteredData
                .filter((x) => x.category === "Converting from Granular to Raw")
                .map((item, index) => {
                  return (
                    <FaqItem
                      key={index}
                      question={item.question}
                      answer={item.answer}
                    />
                  );
                })}
            </div>
          )}

        {(activeSection === "All" || activeSection === "Adding notes") &&
          filteredData.some((x) => x.category === "Adding notes") && (
            <div className="detail-section">
              <div className="header-section">
                <h1>Adding notes</h1>
                <hr className="line" />
              </div>
              {filteredData
                .filter((x) => x.category === "Adding notes")
                .map((item, index) => {
                  return (
                    <FaqItem
                      key={index}
                      question={item.question}
                      answer={item.answer}
                    />
                  );
                })}
            </div>
          )}

        {(activeSection === "All" ||
          activeSection === "Saving a new formula") &&
          filteredData.some((x) => x.category === "Saving a new formula") && (
            <div className="detail-section">
              <div className="header-section">
                <h1>Saving a new formula</h1>
                <hr className="line" />
              </div>
              {filteredData
                .filter((x) => x.category === "Saving a new formula")
                .map((item, index) => {
                  return (
                    <FaqItem
                      key={index}
                      question={item.question}
                      answer={item.answer}
                    />
                  );
                })}
            </div>
          )}

        {(activeSection === "All" || activeSection === "Formulas Tab") &&
          filteredData.some((x) => x.category === "Formulas Tab") && (
            <div className="detail-section">
              <div className="header-section">
                <h1>Formulas Tab</h1>
                <hr className="line" />
              </div>
              {filteredData
                .filter((x) => x.category === "Formulas Tab")
                .map((item, index) => {
                  return (
                    <FaqItem
                      key={index}
                      question={item.question}
                      answer={item.answer}
                    />
                  );
                })}
            </div>
          )}

        {(activeSection === "All" || activeSection === "Prescription Tab") &&
          filteredData.some((x) => x.category === "Prescription Tab") && (
            <div className="detail-section">
              <div className="header-section">
                <h1>Prescription Tab</h1>
                <hr className="line" />
              </div>
              {filteredData
                .filter((x) => x.category === "Prescription Tab")
                .map((item, index) => {
                  return (
                    <FaqItem
                      key={index}
                      question={item.question}
                      answer={item.answer}
                    />
                  );
                })}
            </div>
          )}

        {(activeSection === "All" || activeSection === "Patient Tab") &&
          filteredData.some((x) => x.category === "Patient Tab") && (
            <div className="detail-section">
              <div className="header-section">
                <h1>Patient Tab</h1>
                <hr className="line" />
              </div>
              {filteredData
                .filter((x) => x.category === "Patient Tab")
                .map((item, index) => {
                  return (
                    <FaqItem
                      key={index}
                      question={item.question}
                      answer={item.answer}
                    />
                  );
                })}
            </div>
          )}

        {(activeSection === "All" || activeSection === "Software") &&
          filteredData.some((x) => x.category === "Software") && (
            <div className="detail-section">
              <div className="header-section">
                <h1>Software</h1>
                <hr className="line" />
              </div>
              {filteredData
                .filter((x) => x.category === "Software")
                .map((item, index) => {
                  return (
                    <FaqItem
                      key={index}
                      question={item.question}
                      answer={item.answer}
                    />
                  );
                })}
            </div>
          )}

        {(activeSection === "All" || activeSection === "Account & Privacy") &&
          filteredData.some((x) => x.category === "Account & Privacy") && (
            <div className="detail-section">
              <div className="header-section">
                <h1>Account & Privacy</h1>
                <hr className="line" />
              </div>
              {filteredData
                .filter((x) => x.category === "Account & Privacy")
                .map((item, index) => {
                  return (
                    <FaqItem
                      key={index}
                      question={item.question}
                      answer={item.answer}
                    />
                  );
                })}
            </div>
          )}

        {(activeSection === "All" || activeSection === "Shipping & Payments") &&
          filteredData.some((x) => x.category === "Shipping & Payments") && (
            <div className="detail-section">
              <div className="header-section">
                <h1>Shipping & Payments</h1>
                <hr className="line" />
              </div>
              {filteredData
                .filter((x) => x.category === "Shipping & Payments")
                .map((item, index) => {
                  return (
                    <FaqItem
                      key={index}
                      question={item.question}
                      answer={item.answer}
                    />
                  );
                })}
            </div>
          )}

        {(activeSection === "All" ||
          activeSection === "Herbs & Instructions") &&
          filteredData.some((x) => x.category === "Herbs & Instructions") && (
            <div className="detail-section">
              <div className="header-section">
                <h1>Herbs & Instructions</h1>
                <hr className="line" />
              </div>
              {filteredData
                .filter((x) => x.category === "Herbs & Instructions")
                .map((item, index) => {
                  return (
                    <FaqItem
                      key={index}
                      question={item.question}
                      answer={item.answer}
                    />
                  );
                })}
            </div>
          )}

        {(activeSection === "All" || activeSection === "Security & Privacy") &&
          filteredData.some((x) => x.category === "Security & Privacy") && (
            <div className="detail-section">
              <div className="header-section">
                <h1>Security & Privacy</h1>
                <hr className="line" />
              </div>
              {filteredData
                .filter((x) => x.category === "Security & Privacy")
                .map((item, index) => {
                  return (
                    <FaqItem
                      key={index}
                      question={item.question}
                      answer={item.answer}
                    />
                  );
                })}
            </div>
          )}

        {(activeSection === "All" ||
          activeSection === "Payments, Shipping & Returns") &&
          filteredData.some(
            (x) => x.category === "Payments, Shipping & Returns"
          ) && (
            <div className="detail-section">
              <div className="header-section">
                <h1>Payments, Shipping & Returns</h1>
                <hr className="line" />
              </div>
              {filteredData
                .filter((x) => x.category === "Payments, Shipping & Returns")
                .map((item, index) => {
                  return (
                    <FaqItem
                      key={index}
                      question={item.question}
                      answer={item.answer}
                    />
                  );
                })}
            </div>
          )}

        {(activeSection === "All" || activeSection === "Other") &&
          filteredData.some((x) => x.category === "Other") && (
            <div className="detail-section">
              <div className="header-section">
                <h1>Other</h1>
                <hr className="line" />
              </div>
              {filteredData
                .filter((x) => x.category === "Other")
                .map((item, index) => {
                  return (
                    <FaqItem
                      key={index}
                      question={item.question}
                      answer={item.answer}
                    />
                  );
                })}
            </div>
          )}

        {(activeSection === "All" || activeSection === "Safety") &&
          filteredData.some((x) => x.category === "Safety") && (
            <div className="detail-section">
              <div className="header-section">
                <h1>Safety</h1>
                <hr className="line" />
              </div>
              {filteredData
                .filter((x) => x.category === "Safety")
                .map((item, index) => {
                  return (
                    <FaqItem
                      key={index}
                      question={item.question}
                      answer={item.answer}
                    />
                  );
                })}
            </div>
          )}
      </div>
    </div>
  );
};

export default Faq;
